// import ChartV5 from '../../pages/conocimiento/ChartV5';
import ChartApi from '../../pages/atributos-gestion/ChartApi';

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            {/* <ChartV5/> */}
            <ChartApi piePagina={''} />
          </div>
        </div>
      </div>
    </div>
  )
}
